// Module
var code = "<div class=\"widget_header\"></div>\n<div class=\"widget_content\"></div>";
// Exports
module.exports = code;